<template>
  <div class="take-picture-wrapper">
    <div class="image-stream-box">
      <p class="tip">请竖拍处方笺</p>

      <img v-if="isConnection" class="image-stream" :src="gaoImgSrc" alt="" />

      <div v-else class="image-stream-error">
        <img :src="require('@/assets/img/icon_equipment.png')" alt="" />
        <p>未检测到高拍仪设备，请检查</p>
      </div>

      <div class="take-btn-box">
        <p v-if="isConnection" class="btn" @click="grabImageBase64">
          <img :src="require('@/assets/img/icon_photo.png')" alt="" />
          <span>拍摄</span>
        </p>
      </div>
    </div>
    <pre-example title="拍摄示例" :url="require('@/assets/img/pre_eg_1.png')"></pre-example>
  </div>
</template>

<script>
import photoApi from '@/api/photoApi';
import preExample from './preExample';
import { PHOTO_TYPE } from '@/lib/constant';
const GAO_IMG_SRC = 'http://127.0.0.1:38088/video=stream&camidx=0';
let timer = null;
export default {
  name: 'takePicture',
  components: { preExample },
  data() {
    return {
      gaoImgSrc: '',
      isConnection: true
    };
  },
  created() {
    this.init();
  },
  destroyed() {
    clearTimeout(timer);
  },
  methods: {
    init() {
      this.getResolution();
      this.showCutPage(true);
      this.getVideStatus();
    },
    async getResolution() {
      try {
        let res = await photoApi.getResolution({ type: 'resolution', camidx: 0 });
      } catch (error) {}
    },
    async showCutPage(bShow) {
      try {
        let res = await photoApi.setResolution({
          cutpage: bShow ? 'true' : 'false',
          cutratio: '0.71'
        });
      } catch (error) {}
    },
    getVideStatus() {
      this._getVideStatus();
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        this.getVideStatus();
      }, 2000);
    },
    async _getVideStatus() {
      try {
        let { video0 } = await photoApi.getVideStatus({});
        if (['ok', 'run'].includes(video0)) {
          this.gaoImgSrc = GAO_IMG_SRC;
          this.isConnection = true;
        } else {
          this.initGaoImage();
        }
      } catch (error) {
        this.initGaoImage();
        clearTimeout(timer);
      }
    },
    async grabImageBase64() {
      try {
        const { photoBase64 } = await photoApi.grabImageBase64({
          filepath: 'base64',
          width: '1104',
          height: '1563',
          rotate: 0,
          camidx: 0,
          cutpage: 1
        });
        const imageSrc = 'data:image/jpg;base64,' + photoBase64;
        const file = this.dataURLtoFile(imageSrc);
        this.$emit('getImageUrl', file);
      } catch (error) {}
    },
    initGaoImage() {
      this.gaoImgSrc = '';
      this.isConnection = false;
    },
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    }
  }
};
</script>

<style lang="scss" scoped>
.take-picture-wrapper {
  display: flex;
  .image-stream-box {
    font-size: 14px;
    position: relative;
    width: 752px;
    height: 521px;
    background: #f7f9fa;
    border-radius: 4px;
    border: 1px solid #ededed;
    margin-right: 16px;
    .image-stream {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
    .image-stream-error {
      text-align: center;
      margin-top: 203px;
      color: #bdbdbd;
      img {
        width: 18px;
        height: 24px;
      }
    }
    .tip {
      position: absolute;
      top: 0;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #ffffff;
      background: linear-gradient(180deg, rgba(36, 36, 36, 0.2) 0%, rgba(36, 36, 36, 0) 100%);
    }
    .take-btn-box {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      bottom: 0;
      height: 72px;
      width: 100%;
      background: linear-gradient(360deg, rgba(36, 36, 36, 0.2) 0%, rgba(36, 36, 36, 0) 100%);
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        width: 128px;
        height: 40px;
        line-height: 40px;
        box-shadow: 0px 2px 16px 0px rgba(36, 36, 36, 0.1);
        border-radius: 20px;
        border: 1px solid #ffffff;
        color: #ffffff;
        img {
          height: 18px;
          width: 18px;
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
